import ValidService from '../../../service/ValidService';
let model = {};

// dữ liệu form
model.dataForm = {
  "name": null, // required
  "company_id": null, // required Mã công ty
  "code": null, // required
  "type": null, // required,
  "disabled": false, // required Đã bị khóa chưa
  "description": null, // optional - Description
  "identity": null, // required Định danh
  "is_broken": false, // required
  "status": null, // required enum(NEW, BROKEN_REPORT, BROKEN_CONFIRMED, RECALL_REPORT, RECALL_CONFIRMED, ALLOCATION_REQUEST, ALLOCATION_CONFIRMED, LIQUIDATION) - Trạng thái tài sản: Mới, báo hỏng, xác nhận hỏng, báo thu hồi, xác nhận thu hồi, báo cấp phát, xác nhận cấp phát, thanh lý
  "status_order": null,
  "employee_id": null,
  "asset_id": null,
  "file_ids": [], // optional - Ảnh tài sản
  "origin_price": null, // optional - Giá ban đầu
  "is_atrophy": false, // optional - Có tiêu hao hay không
  "expired_atrophy": null, // optional - Thời gian hết hạn tiêu hao
};

// validation form
model.validForm = {
  "name": [
    ValidService.required,
    ValidService.checkSpaceString,
    ValidService.checkVietNameseHaveNumber
  ], // required Tên chi nhánh
  "company_id": [ValidService.requiredChange], // required Mã công ty
  "code": [
    ValidService.required,
    ValidService.checkSpaceString,
    ValidService.checkVietNameseHaveNumber,
    ValidService.checkSpaceStringCenter
  ], // required
  "type": [ValidService.required, ValidService.checkSpaceString, ValidService.requiredChange],
  "disabled": [], // required Đã bị khóa chưa
  "identity": [ValidService.required, ValidService.checkSpaceString, ValidService.checkSpaceStringCenter, ValidService.checkVietNameseHaveNumber], // required
  "is_broken": [ValidService.requiredChange], // required
  "status": [ValidService.requiredChange], // required
  "employee_id": [ValidService.requiredChange],
  "asset_id": [ValidService.requiredChange],
};

// dữ liệu mẫu các form khác
model.dataFormOther = {

};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  skip: 0,
  sort: "",
  defaultSort: ["status_order", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      "emp_names": "",
      "asset_names": "",
      "name": "",
      "value": "",
      "type": "",
      "identity": "",
      "status": "",
      "is_broken": "",
    },
    valid: {
      "emp_names": [],
      "asset_names": [],
      "name": [],
      "value": [],
      "type": [],
      "identity": [ValidService.checkSpaceString, ValidService.checkSpaceStringCenter],
      "status": [],
      "is_broken": [],
    },
    operator: {
      "emp_names": "$vn_text=",
      "asset_names": "$vn_text=",
      "name": "$vn_text=",
      "value": "",
      "identity": ":regex_i:",
      "status": ":in:",
      "is_broken": "",
    }
  }
};

export default model;
